



































import Vue from 'vue'
import Dialog from '@/components/Dialog.vue'
import DragAndDrop from './DragAndDrop.vue'
import FileInput from './FileInput.vue'
import CameraInput from './CameraInput.vue'

export default Vue.extend({
  components: {
    appFileInput: FileInput,
    appDragAndDrop: DragAndDrop,
    appCameraInput: CameraInput,
    appDialog: Dialog,
  },
  data() {
    return {
      dialog: false,
    }
  },
  methods: {
    onCameraInput(payload: Blob) {
      this.dialog = false
      this.onInput(payload)
    },
    onInput(payload: Blob) {
      this.$emit('input', payload)
    },
  },
})
